import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { AgentTokyoVault } from '../../characters/AgentTokyo';
import { DialogueData } from '../../../../general/Dialogue';
import { CharacterDialogue } from '../../../../general/Character';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { t } from 'ttag';

const VaultIntro: React.FC<ISlide> = ({ defaultHeader, nextSlide }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: AgentTokyoVault,
            text: t`Right, we’re finally here. The vault seems to have some sequences etched into it by Dr Mischief.`,
            buttonText: t`Show sequences`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default VaultIntro;
